import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { BenefactorModel } from '../models/benefactor';
import { BenefactorDataModel } from '../models/benefactorData';
import { AccountModel } from '../models/account';
import { map } from 'rxjs/operators/map';
import { RegisterOfBenefactorsComponent } from './register-of-benefactors.component';
import { Bank } from '../models/banks';
import { CpfCnpjPipe } from '../../shared/cpf-cnpj.pipe';
import { Account } from '../../autentication/models/account';
import { Ownership } from '../models/ownership';
import { Auth } from '../../autentication/Auth';
import { AccountNumberPipe } from '../../shared/account-number.pipe';


@Injectable()
export class RegisterOfBenefactorsService {

	banks: Array<Bank>;

	constructor(private http: HttpClient) { }

	getAll() {
		return this.http.get( endpoints.benefactors.all, {}).pipe( map( (data: any) => {
			const CP = new CpfCnpjPipe();
			const accNumPipe = new AccountNumberPipe();

			let benefactors: Array<BenefactorModel> = [];

			if (data.Sucesso) {

				benefactors = data.Retorno.map(item => {

					let benefactor: BenefactorModel;
					let accounts: Array<AccountModel> = [];

					accounts = item.Contas.map(item => {
						let account: AccountModel;
						let modalityAll: string;

						switch (item.TpConta) {
							case 'CC':
								modalityAll = 'Conta Corrente';
								break;
							case 'PP':
								modalityAll = 'Conta Poupança';
								break;
							case 'PG':
								modalityAll = 'Conta Pagamento';
								break;
						}

						account = {
							id: item.Id,
							agency: item.Agencia,
							accountNumber: accNumPipe.transform(item.NroConta),
							bankCode: item.Banco,
							bankDesc: item.NomeBanco,
							modality: item.TpConta,
							modalityAll: modalityAll
						}

						return account;
					});

					const CP = new CpfCnpjPipe();

					benefactor = {
						name: item.Titular,
						cpfCnpj: CP.transform(item.CpfCnpj),
						ownership: (Auth.getInstance().getUser().cpfCnpj === item.CpfCnpj ? 1 : 2),
						accounts: accounts
					}

					return benefactor;
				});

				return benefactors;
			}

		}));
	}

	getBanks(): Observable<Bank[]> {

		return this.http.get(endpoints.utils.banks).pipe(map((data: any) => {

			if (data.Sucesso) {

				this.banks = data.Retorno.map(item => {
					const bank = new Bank();
					bank.name = item.Nome.toLowerCase();
					bank.code = item.CodigoCompensacao;
					bank.label = bank.code + ' - ' + bank.name;
					bank.ispbCode = item.CodigoISPB;
					bank.popular = item.Popular;

					return bank;
				});

			}

			return this.banks;

		}));
	}

	save(benefactor: BenefactorDataModel): Observable<any> {
		const benefactorData = {
			Id: benefactor.id ? benefactor.id : null,
			CpfCnpj: benefactor.cpfCnpj,
			Titular: benefactor.name,
			Banco: benefactor.bankCode,
			Agencia: benefactor.agency,
			NroConta: benefactor.accountNumber.replace(/\D/g, ''),
			TpConta: benefactor.modality
		};

		if (!benefactor.id) {
			return this.http.post( endpoints.benefactors.all, benefactorData ).pipe( map( (data: any) => {

				return data;

			}));
		} else {
			return this.http.put( endpoints.benefactors.all, benefactorData ).pipe( map( (data: any) => {

				return data;

			}));
		}
	}

	delete(id) {
		return this.http.delete( endpoints.benefactors.all + '?Id=' + id).pipe( map( (data: any) => {
			return data;
		}));
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/register-of-benefactors/register-of-benefactors.service.ts